import React, { useState ,useEffect} from "react";

import { ActionIcon, Center } from "@mantine/core";
import SRD_DataTable from "components/DataTable";
import { download } from "pages/Admin/Library/apis/adminLibraryApis";
import { getManualList } from "pages/Admin/AdminManual/apis/adminManualApis";
import { useQuery } from "react-query";
import { useRecoilState } from "recoil";
import { userState } from "pages/Login/atom/userState";
import { PAGE_SIZE } from "CommonData";

function ManualDataTable() {
  const [page, setPage] = useState(1);
  const [user, setUser] = useRecoilState(userState);
  const groupId = user.fn_group_id;

  const { data } = useQuery(["manualData", page], () =>
    getManualList(PAGE_SIZE, page, groupId)
  );

  useEffect(() => {
    if (!data || data?.length < 1) return;
    data.map((item) => {
      let used_scope = "전체";
      if (item.menu !== "M"){
        used_scope = "그룹 내부";
      }
      item["used_scope"] = used_scope;
    });
  });

  const columns = [
    {
      accessor: "index",
      title: "번호",
      textAlignment: "center",
      width: 30,
      render: (record) => data.indexOf(record) + 1,
    },
    {
      accessor: "used_scope",
      title: "공개범위",
      textAlignment: "center",  
    },
    {
      accessor: "title",
      title: "제목",
    },
    {
      accessor: "registration_date",
      title: "등록일",
    },
    {
      accessor: "file_type",
      title: "파일 형식",
    },
    {
      accessor: "file_name",
      title: "파일 다운로드",
      cellsStyle: {
        color: "blue",
        textDecoration: "underline",
      },
      render: (e) => (
        <Center>
          <ActionIcon onClick={() => download(e)}>
            <img
              src="https://api.iconify.design/bi:file-earmark-arrow-down.svg?color=Black"
              alt="download"
            />
          </ActionIcon>
        </Center>
      ),
    },
  ];

  return (
    <SRD_DataTable
      data={data}
      columns={columns}
      page={page}
      setPage={setPage}
    />
  );
}

export default ManualDataTable;
